import { type ReactElement } from 'react';

/**
 * Marken-Logo (Saldify) als Inline-SVG — eine Quelle der Wahrheit fuer Landing
 * und App. Basiert auf /public/brand/logo-full.svg. Inline statt <img>, damit
 * sich die Wortmarke je Kontext einfaerben laesst (z.B. hell auf dunklem Footer)
 * und keine zusaetzliche Netzwerk-Anfrage entsteht.
 *
 * - variant 'full' (Standard): Kachel-Mark + Wortmarke "Saldify".
 * - variant 'mark': nur die quadratische Kachel mit "S" (z.B. enge Header).
 * - light: fuer dunkle Hintergruende — die Wortmarke "Saldi" wird weiss.
 */
export function Logo({
  variant = 'full',
  light = false,
  className,
  title = 'Saldify',
}: {
  variant?: 'full' | 'mark';
  light?: boolean;
  className?: string;
  title?: string;
}): ReactElement {
  // 'Saldi' nutzt currentColor, sodass die Wortmarke der Textfarbe des Aufrufers
  // folgt (Tailwind text-* + dark:text-*). So wird sie im Darkmode automatisch
  // hell, ohne dass der Aufruf-Kontext einen Prop kennen muss. light=true
  // erzwingt Weiss (z.B. fester dunkler Footer ohne dark:-Klassen).
  const wordPrimary = light ? '#FFFFFF' : 'currentColor';
  const gradId = light ? 'saldify-mark-light' : 'saldify-mark';

  if (variant === 'mark') {
    return (
      <svg viewBox="0 0 56 56" className={className} role="img" aria-label={title} xmlns="http://www.w3.org/2000/svg">
        <title>{title}</title>
        <defs>
          <linearGradient id={gradId} x1="6" y1="6" x2="46" y2="50" gradientUnits="userSpaceOnUse">
            <stop stopColor="#3B82F6" />
            <stop offset="1" stopColor="#1D4ED8" />
          </linearGradient>
        </defs>
        <rect x="4" y="4" width="48" height="48" rx="13" fill={`url(#${gradId})`} />
        <text x="28" y="41" textAnchor="middle" fontFamily="Inter, 'Segoe UI', system-ui, sans-serif" fontSize="36" fontWeight="800" fill="#FFFFFF">S</text>
      </svg>
    );
  }

  return (
    <svg viewBox="0 0 220 56" className={className} role="img" aria-label={title} xmlns="http://www.w3.org/2000/svg">
      <title>{title}</title>
      <defs>
        <linearGradient id={gradId} x1="6" y1="6" x2="46" y2="50" gradientUnits="userSpaceOnUse">
          <stop stopColor="#3B82F6" />
          <stop offset="1" stopColor="#1D4ED8" />
        </linearGradient>
      </defs>
      {/* Mark */}
      <rect x="4" y="4" width="48" height="48" rx="13" fill={`url(#${gradId})`} />
      <text x="28" y="41" textAnchor="middle" fontFamily="Inter, 'Segoe UI', system-ui, sans-serif" fontSize="36" fontWeight="800" fill="#FFFFFF">S</text>
      {/* Wortmarke: Saldi + fy (blauer Akzent) */}
      <text x="66" y="37" fontFamily="Inter, 'Segoe UI', system-ui, sans-serif" fontSize="30" fontWeight="700" letterSpacing="-0.5">
        <tspan fill={wordPrimary}>Saldi</tspan><tspan fill="#2563EB">fy</tspan>
      </text>
    </svg>
  );
}

export default Logo;
